module.exports = __webpack_public_path__ + "img/icon_FAQ_settings_active.f7ae4143.svg";